module.exports = __webpack_public_path__ + "img/mensaje__verde.4cf7a3c9.svg";